import { useEffect, useState } from 'react'
import { fetchInsurances, type InsurancesResponse } from '../../lib/api'
import { insuranceLabels } from '../../steps/stepDefinitions'
import { useFlowFilter } from '../FlowFilterContext'

interface Props { range: { from: number; to: number } }

const fmt = (n: number) => n.toLocaleString('da-DK')

function labelFor(id: string): string {
  const labels = insuranceLabels as Record<string, string>
  return labels[id] ?? id
}

export function InsuranceMix({ range }: Props) {
  const { variantParam, audienceParam } = useFlowFilter()
  const [data, setData] = useState<InsurancesResponse | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setData(null); setError(null)
    fetchInsurances(range, variantParam, audienceParam)
      .then((d) => { if (!cancelled) setData(d) })
      .catch((e) => { if (!cancelled) setError(String(e)) })
    return () => { cancelled = true }
  }, [range.from, range.to, variantParam, audienceParam])

  if (error) return <div className="card card-empty">Kunne ikke hente forsikrings-mix</div>
  if (!data) return <div className="card card-skeleton" aria-busy />
  if (data.total === 0) return (
    <div className="card card-empty"><div className="card-title">Forsikrings-mix</div><div className="muted">Ingen leads i perioden</div></div>
  )

  const max = Math.max(1, ...data.items.map((i) => i.n))

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">Forsikrings-mix</div>
        <div className="card-subtitle">Hvad har leads allerede</div>
      </div>
      <div className="card-note small">
        Multi-product rate: <strong>{(data.multiInsuranceRate * 100).toFixed(0)}%</strong> har 2+ forsikringer
      </div>
      <div className="hbar-list">
        {data.items.map((it) => (
          <div key={it.insurance} className="hbar-row">
            <div className="hbar-label">{labelFor(it.insurance)}</div>
            <div className="hbar-track">
              <div className="hbar-fill" style={{ width: `${(it.n / max) * 100}%` }} />
            </div>
            <div className="hbar-num">{fmt(it.n)} <span className="muted">· {(it.pct * 100).toFixed(0)}%</span></div>
          </div>
        ))}
      </div>
    </div>
  )
}
